export default {
    _linotte_bolduploaded_file: 'linotte-bolduploaded_file',
    _nougatregular: 'nougatregular',
}